import { FocusEventHandler, ReactNode } from 'react';
import ReactInputMask from 'react-input-mask';
import TextInputBase from './TextInputBase';
import { useContextField } from '../../../api';
import { ErrorMessage, FormLabel } from '../helpers';

export default (props: {
    label?: string | ReactNode;
    name: string;
    mask: string | Array<(string | RegExp)>;
    disabled?: boolean;
    endAdornment?: ReactNode;
    setStringValue?: boolean;
    className?: string;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    placeholder?: string;
}) => {
    const { className, endAdornment, label, name, onBlur, setStringValue, placeholder, ...rest } = props;
    const [field, _, helper] = useContextField<string | number | undefined>(name);

    return <>
        <FormLabel label={label} />
        <ReactInputMask
            {...rest}
            placeholder={placeholder}
            name={name}
            value={field.value === undefined || field.value === null ? '' : String(field.value)}
            maskPlaceholder={null}
            onBlur={onBlur}
            onChange={e => {
                const value = e.target.value;
                if (value !== '') {
                    helper.setValue(setStringValue ? value : Number(value));
                } else {
                    helper.setValue(undefined);
                }
            }}>
            <TextInputBase inputMode="numeric" endAdornment={endAdornment} className={className} variant="outlined" />
        </ReactInputMask>
        <ErrorMessage name={name} />
    </>
}
